// extracted by mini-css-extract-plugin
module.exports = {"loading":"PatientDetailsActivity_loading__1pI7X","container":"PatientDetailsActivity_container__3d5Mo"};